// Module
var code = `  <print-header class="print-only" branch-id="\$ctrl.printBranchId" print-name="'Transaction mapping'"></print-header>

  <div class="filters no-print">
    <span class="labelled-field">
      <label class="add-on">Mapping name</label>
      <input type="text" class="filter-value" ng-model="\$ctrl.glFilter.filterName">
    </span>
    <button type="button" class="btn btn-print" ng-if="!\$ctrl.edit" ng-click="\$ctrl.print()">Print</button>
    <button type="button" class="btn btn-danger" ng-click="\$ctrl.onEdit()">{{\$ctrl.edit ? 'Disable editing' : 'Edit'}}
    </button>
  </div>

  <div>
    <table ng-table="\$ctrl.tableConfig"  class="table gl-mappings__table">
      <tr ng-repeat="tag in \$data">
        <td data-title="'No'">{{\$index + 1}}</td>
        <td data-title="'Mapping type'" sortable="'tagType'">{{tag.tagType}}</td>
        <td data-title="'Mapping name'" sortable="'mappingName'" header-class="'col-name'">{{tag.mappingName}}</td>
        <td data-title="'Use mapping'" class="centered-cell" header-class="'centered-cell'">
          <input
              ng-if="\$ctrl.edit"
              type="checkbox"
              ng-model="tag.delegate"
              ng-change="\$ctrl.onDelegateChange(tag)"/>
          {{ \$ctrl.edit ? '' : (tag.delegate ? 'Yes' : '-')}}
        </td>
        <td data-title="'Source mapping'" class="col-account">
          <selectize
            ng-if="\$ctrl.edit"
            ng-disabled="!tag.delegate"
            options="\$ctrl.getTagTypes(tag)"
            ng-required="tag.delegate"
            config="\$ctrl.selectConfig"
            ng-model="tag.delegateTagType">
          </selectize>
          {{ \$ctrl.edit ? '' : tag.delegateTagType | prettyEnum }}
        </td>
        <td data-title="'GL account'" class="col-account">
          <div ng-if="tag.delegate">
            <selectize
              ng-if="\$ctrl.edit"
              ng-disabled="tag.delegate"
              ng-model="\$ctrl.devnull"
              config="\$ctrl.emptyAccountConfig"
              options="[]">
            </selectize>
            {{\$ctrl.edit ? '' : '-'}}
          </div>
          <div ng-if="!tag.delegate">
            <account-select
              ng-if="\$ctrl.edit && !tag.delegate"
              options="tag.tagType === 'LABELED_ACCOUNT' ? \$ctrl.allLedgerAccounts : \$ctrl.ledgerAccounts"
              ng-model="tag"
              query-field="'accountCode'"
              label-field="'label'"
              value-field="'fullCode'"
              ng-required="!tag.delegate">
            </account-select>
            {{ \$ctrl.edit ? '' : tag.accountCode }}
          </div>
        </td>
        <td class="centered-cell col-button">
          <button
            ng-if="\$ctrl.edit"
            type="submit"
            class="btn btn-primary"
            ng-click="\$ctrl.saveTag(tag)">
            Save
          </button>
        </td>
      </tr>
    </table>
  </div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/general-ledger/transaction-mapping/gl-transaction-mapping.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;